import { c as _c } from "react/compiler-runtime";
import { ActionButton } from "./CreateWaveInlineGroupButtons";
export default function CreateWaveInlineGroupActions(t0) {
  const $ = _c(13);
  const {
    disabled,
    onAddIdentity,
    onAddRule,
    onUseExistingGroup
  } = t0;
  let t1;
  if ($[0] !== disabled || $[1] !== onAddIdentity) {
    t1 = <ActionButton label="Add identity" disabled={disabled} onClick={onAddIdentity} />;
    $[0] = disabled;
    $[1] = onAddIdentity;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== disabled || $[4] !== onAddRule) {
    t2 = <ActionButton label="Add rule" disabled={disabled} onClick={onAddRule} />;
    $[3] = disabled;
    $[4] = onAddRule;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== disabled || $[7] !== onUseExistingGroup) {
    t3 = <ActionButton label="Use existing group" disabled={disabled} onClick={onUseExistingGroup} />;
    $[6] = disabled;
    $[7] = onUseExistingGroup;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t1 || $[10] !== t2 || $[11] !== t3) {
    t4 = <div className="tw-flex tw-flex-wrap tw-gap-2">{t1}{t2}{t3}</div>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}